import { Theme } from '@emotion/react';
import { SxProps } from '@mui/system';

const styles = {
  container: {
    flexDirection: 'column',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    color: 'grey.800',
    fontWeight: '600',
    fontSize: '14px',
    ml: '10px',
  },
  dateBoxGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2,1fr)',
    columnGap: '10px',
  },
  selectRequestText: {
    fontSize: 14,
    fontWeight: '500',
    color: 'grey.800',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
